/* eslint-disable @typescript-eslint/no-use-before-define */
import * as React from 'react';
import {SocialAuthIntegration} from '@practicegenius/domain/src/data/integrations';
import {Modal} from '../../../components/Modal/Modal';
import {Content, Title} from '../../../shared/utils/sharedStyledElements';
import {SocialLoginButtons} from '../../../components/SitesDotSocialLoginButtons';

type Props = {
  isOpen: boolean;
  close: () => void;
  message: string;
  socialAccounts: ReadonlyArray<SocialAuthIntegration>;
  onLoginError: React.ComponentProps<typeof SocialLoginButtons>['onLoginError'];
};

export function SociallyRegisteredModal({
  isOpen,
  close,
  message,
  socialAccounts,
  onLoginError,
}: Props) {
  return (
    <Modal isOpen={isOpen} close={close}>
      <Title>Social Login</Title>
      <Content>
        {message}
        <br />
        <br />
        To log in with your email or username, add a password to your profile.
      </Content>
      <SocialLoginButtons
        platforms={socialAccounts}
        onLoginError={onLoginError}
      />
    </Modal>
  );
}
